import styled from 'styled-components';
import { Input, Button, Select } from 'antd';

export const StyledLabelWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledRefreshButton = styled(Button)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_4} !important;
  &:hover {
    background: transparent;
  }
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_3};

  .ant-select-selector {
    min-height: ${({ theme }) => theme.spacing.space_5} !important;
    height: auto !important;
  }
`;

export const StyledDropdownCreateButton = styled(Button)`
  width: 100%;
  text-align: left;
  padding: 4px 12px;

  &:hover {
    background: ${({ theme }) => theme.palette.neutrals.snow};
  }
`;

export const StyledEntryRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_2};
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledEntryInput = styled(Input)`
  flex: 1;
`;

export const StyledRemoveButton = styled(Button)`
  flex-shrink: 0;
`;
